module.exports = __webpack_public_path__ + "img/PCT06.895192f9.svg";